export default __webpack_public_path__ + "static/media/ya.cf3e78fa.png";